<template>
    <div id="EnHome">
        <EnHomeBanner></EnHomeBanner>
        <section id="home-statistics-map">
            <h1 class="h1 center">Statistics of marine debris</h1>
            <suspense>
                <template #default>
                    <EnStatisticsMap></EnStatisticsMap>
                </template>
                <template #fallback>
                    <div>Loading...</div>
                </template>
            </suspense>
        </section>
    </div>
</template>
<script>
export default {
    name: 'EnHome',
}
</script>
<script setup>
import { defineAsyncComponent } from 'vue'
import { EnHomeBanner } from '@/components/en'
const EnStatisticsMap = defineAsyncComponent(() =>
    import('@/components/en/EnStatisticsMap.vue')
)
</script>
<style lang="scss" scoped></style>
